'use strict';

var jimdoData = require('jimdoData');
if (jimdoData.bgConfig) {
    require('./init.backgroundArea')(jimdoData.bgConfig);
}



/*****************
 ** WEBPACK FOOTER
 ** ./webserver/document_root/s/js/web/scripts/bootstrap.backgroundArea.js
 ** module id = 3684
 ** module chunks = 99
 **/